import {
  getSessionEpoch,
  isCurrentSessionEpoch,
  noteSessionOwner,
  onSessionEpochChange,
  __resetSessionEpochForTest,
} from '@field-tickets/shared';

/**
 * The web's view of the shared session epoch (#967,
 * packages/shared/src/utils/sessionEpoch.ts). It moves on sign-out, when the
 * session expires (`setUser(null)`) and when a different user signs in.
 * Every async ticket operation (save, close-time flush, offline replay,
 * recovery reload, status change, QuickBooks send) captures it when it
 * starts and touches shared state (the query cache through
 * `setTicketDetail`, recovery drafts, the form, the offline queue) only while
 * it still matches, so a response that lands after a user switch is dropped
 * instead of writing one user's ticket into another user's session.
 */
export function getAuthEpoch(): number {
  return getSessionEpoch();
}

export function isCurrentAuthEpoch(captured: number): boolean {
  return isCurrentSessionEpoch(captured);
}

/** The auth store's user changed (null: signed out or the session expired). */
export function noteSignedInOwner(owner: string | null): void {
  noteSessionOwner(owner);
}

/** Sign-out. */
export function noteSignedOut(): void {
  noteSessionOwner(null);
}

/** Runs after each epoch move (sign-out, expiry, user switch). Returns the unsubscribe. */
export function onAuthEpochChange(listener: () => void): () => void {
  return onSessionEpochChange(listener);
}

export function __resetAuthEpochForTest(): void {
  __resetSessionEpochForTest();
}
